import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AppTranslateService {

  public languageArr:any = ['sv','en'];
  public defaultLanguage:string = 'sv';

  constructor(public translate: TranslateService) {  
    this.addLanguage(['sv','en']);
    //   this.translate.setDefaultLang('sv');
    //   this.translate.use('sv');
    //   localStorage.setItem('appLanguage', 'sv');
  }

  public addLanguage(lang){
    this.languageArr = lang;
    this.translate.addLangs(this.languageArr);
  }
  public setDefaulfLang(lang?){
    if(lang){
      this.translate.setDefaultLang(lang);
      localStorage.setItem('appLanguage', lang);
    } else {
      this.translate.setDefaultLang(this.defaultLanguage);
      localStorage.setItem('appLanguage', this.defaultLanguage);
    }
  }
  public switchLang(lang?){
    if(lang){
      this.translate.use(lang);
      localStorage.setItem('appLanguage', lang);
    } else {
      this.translate.use( this.defaultLanguage);
      localStorage.setItem('appLanguage', this.defaultLanguage);
    }
  }
  public getLangList(){
    return this.translate.getLangs();
  }
  public currentLang(){
    return localStorage.getItem('appLanguage');
  }
}
